import {Messages} from "../../Messages";
import {SubscribeFlowController} from "./SubscribeFlowController";

export class GiftSubscriptionFlowController extends SubscribeFlowController {
    actionButtonTestId = "giftSubscriptionBtn";
    actionButtonDefaultAnid = "gift-subscription-button";
    logInFooterDefaultAnid = "gift-subscription-login-footer";

    getActionButtonDefaultLabel() {
        return super.getActionButtonDefaultLabel() || Messages.giftSubscription;
    }

    getLoginFooterMessage() {
        return Messages.alreadyHaveAnAccount;
    }
}
